import { render, staticRenderFns } from "./UiTablePanel.vue?vue&type=template&id=70a407fe&scoped=true"
import script from "./UiTablePanel.vue?vue&type=script&lang=js"
export * from "./UiTablePanel.vue?vue&type=script&lang=js"
import style0 from "./UiTablePanel.vue?vue&type=style&index=0&id=70a407fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a407fe",
  null
  
)

export default component.exports